import axiosService from "./axios-service";

export const getOutlets = async (outlet = "all") => {
  return axiosService.get(`/sales/incentive/fetch_outlet?outlet=${outlet}`);
};

export const addOutlet = async (data) => {
  return axiosService.post(`/sales/incentive/upsert_outlet`, data);
};

export const uploadOutletFile = (data) => {
  return axiosService.post(`/sales/incentive/v2/upsert_outlet`, data);
};
